import { g as Rn } from "./_commonjsHelpers-C6fGbg64.js";
import He, { useRef as ne, useCallback as te, useEffect as ue, useMemo as It, useLayoutEffect as Tn, useReducer as Pn, cloneElement as Mn, Component as Nn } from "react";
import { _ as $e } from "./tslib.es6-fInlAbov.js";
function pe(t, n) {
  if (t == null) return {};
  var r = {};
  for (var o in t) if ({}.hasOwnProperty.call(t, o)) {
    if (n.indexOf(o) !== -1) continue;
    r[o] = t[o];
  }
  return r;
}
function j() {
  return j = Object.assign ? Object.assign.bind() : function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var o in r) ({}).hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, j.apply(null, arguments);
}
function Ze(t, n) {
  return Ze = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Ze(t, n);
}
function Vn(t, n) {
  t.prototype = Object.create(n.prototype), t.prototype.constructor = t, Ze(t, n);
}
var De = { exports: {} }, Re = { exports: {} }, Y = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yt;
function An() {
  if (yt) return Y;
  yt = 1;
  var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, o = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, e = t ? Symbol.for("react.profiler") : 60114, u = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, f = t ? Symbol.for("react.async_mode") : 60111, E = t ? Symbol.for("react.concurrent_mode") : 60111, I = t ? Symbol.for("react.forward_ref") : 60112, O = t ? Symbol.for("react.suspense") : 60113, S = t ? Symbol.for("react.suspense_list") : 60120, P = t ? Symbol.for("react.memo") : 60115, k = t ? Symbol.for("react.lazy") : 60116, C = t ? Symbol.for("react.block") : 60121, h = t ? Symbol.for("react.fundamental") : 60117, q = t ? Symbol.for("react.responder") : 60118, a = t ? Symbol.for("react.scope") : 60119;
  function d(s) {
    if (typeof s == "object" && s !== null) {
      var D = s.$$typeof;
      switch (D) {
        case n:
          switch (s = s.type, s) {
            case f:
            case E:
            case o:
            case e:
            case i:
            case O:
              return s;
            default:
              switch (s = s && s.$$typeof, s) {
                case c:
                case I:
                case k:
                case P:
                case u:
                  return s;
                default:
                  return D;
              }
          }
        case r:
          return D;
      }
    }
  }
  function l(s) {
    return d(s) === E;
  }
  return Y.AsyncMode = f, Y.ConcurrentMode = E, Y.ContextConsumer = c, Y.ContextProvider = u, Y.Element = n, Y.ForwardRef = I, Y.Fragment = o, Y.Lazy = k, Y.Memo = P, Y.Portal = r, Y.Profiler = e, Y.StrictMode = i, Y.Suspense = O, Y.isAsyncMode = function(s) {
    return l(s) || d(s) === f;
  }, Y.isConcurrentMode = l, Y.isContextConsumer = function(s) {
    return d(s) === c;
  }, Y.isContextProvider = function(s) {
    return d(s) === u;
  }, Y.isElement = function(s) {
    return typeof s == "object" && s !== null && s.$$typeof === n;
  }, Y.isForwardRef = function(s) {
    return d(s) === I;
  }, Y.isFragment = function(s) {
    return d(s) === o;
  }, Y.isLazy = function(s) {
    return d(s) === k;
  }, Y.isMemo = function(s) {
    return d(s) === P;
  }, Y.isPortal = function(s) {
    return d(s) === r;
  }, Y.isProfiler = function(s) {
    return d(s) === e;
  }, Y.isStrictMode = function(s) {
    return d(s) === i;
  }, Y.isSuspense = function(s) {
    return d(s) === O;
  }, Y.isValidElementType = function(s) {
    return typeof s == "string" || typeof s == "function" || s === o || s === E || s === e || s === i || s === O || s === S || typeof s == "object" && s !== null && (s.$$typeof === k || s.$$typeof === P || s.$$typeof === u || s.$$typeof === c || s.$$typeof === I || s.$$typeof === h || s.$$typeof === q || s.$$typeof === a || s.$$typeof === C);
  }, Y.typeOf = d, Y;
}
var U = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Et;
function kn() {
  return Et || (Et = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, o = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, e = t ? Symbol.for("react.profiler") : 60114, u = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, f = t ? Symbol.for("react.async_mode") : 60111, E = t ? Symbol.for("react.concurrent_mode") : 60111, I = t ? Symbol.for("react.forward_ref") : 60112, O = t ? Symbol.for("react.suspense") : 60113, S = t ? Symbol.for("react.suspense_list") : 60120, P = t ? Symbol.for("react.memo") : 60115, k = t ? Symbol.for("react.lazy") : 60116, C = t ? Symbol.for("react.block") : 60121, h = t ? Symbol.for("react.fundamental") : 60117, q = t ? Symbol.for("react.responder") : 60118, a = t ? Symbol.for("react.scope") : 60119;
    function d(m) {
      return typeof m == "string" || typeof m == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      m === o || m === E || m === e || m === i || m === O || m === S || typeof m == "object" && m !== null && (m.$$typeof === k || m.$$typeof === P || m.$$typeof === u || m.$$typeof === c || m.$$typeof === I || m.$$typeof === h || m.$$typeof === q || m.$$typeof === a || m.$$typeof === C);
    }
    function l(m) {
      if (typeof m == "object" && m !== null) {
        var Z = m.$$typeof;
        switch (Z) {
          case n:
            var x = m.type;
            switch (x) {
              case f:
              case E:
              case o:
              case e:
              case i:
              case O:
                return x;
              default:
                var le = x && x.$$typeof;
                switch (le) {
                  case c:
                  case I:
                  case k:
                  case P:
                  case u:
                    return le;
                  default:
                    return Z;
                }
            }
          case r:
            return Z;
        }
      }
    }
    var s = f, D = E, K = c, M = u, F = n, H = I, L = o, B = k, X = P, N = r, Q = e, J = i, re = O, oe = !1;
    function se(m) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), p(m) || l(m) === f;
    }
    function p(m) {
      return l(m) === E;
    }
    function b(m) {
      return l(m) === c;
    }
    function y(m) {
      return l(m) === u;
    }
    function _(m) {
      return typeof m == "object" && m !== null && m.$$typeof === n;
    }
    function v(m) {
      return l(m) === I;
    }
    function w(m) {
      return l(m) === o;
    }
    function R(m) {
      return l(m) === k;
    }
    function T(m) {
      return l(m) === P;
    }
    function V(m) {
      return l(m) === r;
    }
    function $(m) {
      return l(m) === e;
    }
    function A(m) {
      return l(m) === i;
    }
    function G(m) {
      return l(m) === O;
    }
    U.AsyncMode = s, U.ConcurrentMode = D, U.ContextConsumer = K, U.ContextProvider = M, U.Element = F, U.ForwardRef = H, U.Fragment = L, U.Lazy = B, U.Memo = X, U.Portal = N, U.Profiler = Q, U.StrictMode = J, U.Suspense = re, U.isAsyncMode = se, U.isConcurrentMode = p, U.isContextConsumer = b, U.isContextProvider = y, U.isElement = _, U.isForwardRef = v, U.isFragment = w, U.isLazy = R, U.isMemo = T, U.isPortal = V, U.isProfiler = $, U.isStrictMode = A, U.isSuspense = G, U.isValidElementType = d, U.typeOf = l;
  }()), U;
}
var bt;
function Ft() {
  return bt || (bt = 1, process.env.NODE_ENV === "production" ? Re.exports = An() : Re.exports = kn()), Re.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ue, wt;
function Hn() {
  if (wt) return Ue;
  wt = 1;
  var t = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function o(e) {
    if (e == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var e = new String("abc");
      if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5")
        return !1;
      for (var u = {}, c = 0; c < 10; c++)
        u["_" + String.fromCharCode(c)] = c;
      var f = Object.getOwnPropertyNames(u).map(function(I) {
        return u[I];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var E = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(I) {
        E[I] = I;
      }), Object.keys(Object.assign({}, E)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ue = i() ? Object.assign : function(e, u) {
    for (var c, f = o(e), E, I = 1; I < arguments.length; I++) {
      c = Object(arguments[I]);
      for (var O in c)
        n.call(c, O) && (f[O] = c[O]);
      if (t) {
        E = t(c);
        for (var S = 0; S < E.length; S++)
          r.call(c, E[S]) && (f[E[S]] = c[E[S]]);
      }
    }
    return f;
  }, Ue;
}
var We, Ot;
function nt() {
  if (Ot) return We;
  Ot = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return We = t, We;
}
var ze, xt;
function Bt() {
  return xt || (xt = 1, ze = Function.call.bind(Object.prototype.hasOwnProperty)), ze;
}
var Ge, St;
function $n() {
  if (St) return Ge;
  St = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = /* @__PURE__ */ nt(), r = {}, o = /* @__PURE__ */ Bt();
    t = function(e) {
      var u = "Warning: " + e;
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
  }
  function i(e, u, c, f, E) {
    if (process.env.NODE_ENV !== "production") {
      for (var I in e)
        if (o(e, I)) {
          var O;
          try {
            if (typeof e[I] != "function") {
              var S = Error(
                (f || "React class") + ": " + c + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw S.name = "Invariant Violation", S;
            }
            O = e[I](u, I, f, c, null, n);
          } catch (k) {
            O = k;
          }
          if (O && !(O instanceof Error) && t(
            (f || "React class") + ": type specification of " + c + " `" + I + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof O + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), O instanceof Error && !(O.message in r)) {
            r[O.message] = !0;
            var P = E ? E() : "";
            t(
              "Failed " + c + " type: " + O.message + (P ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Ge = i, Ge;
}
var Xe, Ct;
function Kn() {
  if (Ct) return Xe;
  Ct = 1;
  var t = Ft(), n = Hn(), r = /* @__PURE__ */ nt(), o = /* @__PURE__ */ Bt(), i = /* @__PURE__ */ $n(), e = function() {
  };
  process.env.NODE_ENV !== "production" && (e = function(c) {
    var f = "Warning: " + c;
    typeof console < "u" && console.error(f);
    try {
      throw new Error(f);
    } catch {
    }
  });
  function u() {
    return null;
  }
  return Xe = function(c, f) {
    var E = typeof Symbol == "function" && Symbol.iterator, I = "@@iterator";
    function O(p) {
      var b = p && (E && p[E] || p[I]);
      if (typeof b == "function")
        return b;
    }
    var S = "<<anonymous>>", P = {
      array: q("array"),
      bigint: q("bigint"),
      bool: q("boolean"),
      func: q("function"),
      number: q("number"),
      object: q("object"),
      string: q("string"),
      symbol: q("symbol"),
      any: a(),
      arrayOf: d,
      element: l(),
      elementType: s(),
      instanceOf: D,
      node: H(),
      objectOf: M,
      oneOf: K,
      oneOfType: F,
      shape: B,
      exact: X
    };
    function k(p, b) {
      return p === b ? p !== 0 || 1 / p === 1 / b : p !== p && b !== b;
    }
    function C(p, b) {
      this.message = p, this.data = b && typeof b == "object" ? b : {}, this.stack = "";
    }
    C.prototype = Error.prototype;
    function h(p) {
      if (process.env.NODE_ENV !== "production")
        var b = {}, y = 0;
      function _(w, R, T, V, $, A, G) {
        if (V = V || S, A = A || T, G !== r) {
          if (f) {
            var m = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw m.name = "Invariant Violation", m;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Z = V + ":" + T;
            !b[Z] && // Avoid spamming the console because they are often not actionable except for lib authors
            y < 3 && (e(
              "You are manually calling a React.PropTypes validation function for the `" + A + "` prop on `" + V + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), b[Z] = !0, y++);
          }
        }
        return R[T] == null ? w ? R[T] === null ? new C("The " + $ + " `" + A + "` is marked as required " + ("in `" + V + "`, but its value is `null`.")) : new C("The " + $ + " `" + A + "` is marked as required in " + ("`" + V + "`, but its value is `undefined`.")) : null : p(R, T, V, $, A);
      }
      var v = _.bind(null, !1);
      return v.isRequired = _.bind(null, !0), v;
    }
    function q(p) {
      function b(y, _, v, w, R, T) {
        var V = y[_], $ = J(V);
        if ($ !== p) {
          var A = re(V);
          return new C(
            "Invalid " + w + " `" + R + "` of type " + ("`" + A + "` supplied to `" + v + "`, expected ") + ("`" + p + "`."),
            { expectedType: p }
          );
        }
        return null;
      }
      return h(b);
    }
    function a() {
      return h(u);
    }
    function d(p) {
      function b(y, _, v, w, R) {
        if (typeof p != "function")
          return new C("Property `" + R + "` of component `" + v + "` has invalid PropType notation inside arrayOf.");
        var T = y[_];
        if (!Array.isArray(T)) {
          var V = J(T);
          return new C("Invalid " + w + " `" + R + "` of type " + ("`" + V + "` supplied to `" + v + "`, expected an array."));
        }
        for (var $ = 0; $ < T.length; $++) {
          var A = p(T, $, v, w, R + "[" + $ + "]", r);
          if (A instanceof Error)
            return A;
        }
        return null;
      }
      return h(b);
    }
    function l() {
      function p(b, y, _, v, w) {
        var R = b[y];
        if (!c(R)) {
          var T = J(R);
          return new C("Invalid " + v + " `" + w + "` of type " + ("`" + T + "` supplied to `" + _ + "`, expected a single ReactElement."));
        }
        return null;
      }
      return h(p);
    }
    function s() {
      function p(b, y, _, v, w) {
        var R = b[y];
        if (!t.isValidElementType(R)) {
          var T = J(R);
          return new C("Invalid " + v + " `" + w + "` of type " + ("`" + T + "` supplied to `" + _ + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return h(p);
    }
    function D(p) {
      function b(y, _, v, w, R) {
        if (!(y[_] instanceof p)) {
          var T = p.name || S, V = se(y[_]);
          return new C("Invalid " + w + " `" + R + "` of type " + ("`" + V + "` supplied to `" + v + "`, expected ") + ("instance of `" + T + "`."));
        }
        return null;
      }
      return h(b);
    }
    function K(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? e(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : e("Invalid argument supplied to oneOf, expected an array.")), u;
      function b(y, _, v, w, R) {
        for (var T = y[_], V = 0; V < p.length; V++)
          if (k(T, p[V]))
            return null;
        var $ = JSON.stringify(p, function(G, m) {
          var Z = re(m);
          return Z === "symbol" ? String(m) : m;
        });
        return new C("Invalid " + w + " `" + R + "` of value `" + String(T) + "` " + ("supplied to `" + v + "`, expected one of " + $ + "."));
      }
      return h(b);
    }
    function M(p) {
      function b(y, _, v, w, R) {
        if (typeof p != "function")
          return new C("Property `" + R + "` of component `" + v + "` has invalid PropType notation inside objectOf.");
        var T = y[_], V = J(T);
        if (V !== "object")
          return new C("Invalid " + w + " `" + R + "` of type " + ("`" + V + "` supplied to `" + v + "`, expected an object."));
        for (var $ in T)
          if (o(T, $)) {
            var A = p(T, $, v, w, R + "." + $, r);
            if (A instanceof Error)
              return A;
          }
        return null;
      }
      return h(b);
    }
    function F(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && e("Invalid argument supplied to oneOfType, expected an instance of array."), u;
      for (var b = 0; b < p.length; b++) {
        var y = p[b];
        if (typeof y != "function")
          return e(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + oe(y) + " at index " + b + "."
          ), u;
      }
      function _(v, w, R, T, V) {
        for (var $ = [], A = 0; A < p.length; A++) {
          var G = p[A], m = G(v, w, R, T, V, r);
          if (m == null)
            return null;
          m.data && o(m.data, "expectedType") && $.push(m.data.expectedType);
        }
        var Z = $.length > 0 ? ", expected one of type [" + $.join(", ") + "]" : "";
        return new C("Invalid " + T + " `" + V + "` supplied to " + ("`" + R + "`" + Z + "."));
      }
      return h(_);
    }
    function H() {
      function p(b, y, _, v, w) {
        return N(b[y]) ? null : new C("Invalid " + v + " `" + w + "` supplied to " + ("`" + _ + "`, expected a ReactNode."));
      }
      return h(p);
    }
    function L(p, b, y, _, v) {
      return new C(
        (p || "React class") + ": " + b + " type `" + y + "." + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + v + "`."
      );
    }
    function B(p) {
      function b(y, _, v, w, R) {
        var T = y[_], V = J(T);
        if (V !== "object")
          return new C("Invalid " + w + " `" + R + "` of type `" + V + "` " + ("supplied to `" + v + "`, expected `object`."));
        for (var $ in p) {
          var A = p[$];
          if (typeof A != "function")
            return L(v, w, R, $, re(A));
          var G = A(T, $, v, w, R + "." + $, r);
          if (G)
            return G;
        }
        return null;
      }
      return h(b);
    }
    function X(p) {
      function b(y, _, v, w, R) {
        var T = y[_], V = J(T);
        if (V !== "object")
          return new C("Invalid " + w + " `" + R + "` of type `" + V + "` " + ("supplied to `" + v + "`, expected `object`."));
        var $ = n({}, y[_], p);
        for (var A in $) {
          var G = p[A];
          if (o(p, A) && typeof G != "function")
            return L(v, w, R, A, re(G));
          if (!G)
            return new C(
              "Invalid " + w + " `" + R + "` key `" + A + "` supplied to `" + v + "`.\nBad object: " + JSON.stringify(y[_], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(p), null, "  ")
            );
          var m = G(T, A, v, w, R + "." + A, r);
          if (m)
            return m;
        }
        return null;
      }
      return h(b);
    }
    function N(p) {
      switch (typeof p) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !p;
        case "object":
          if (Array.isArray(p))
            return p.every(N);
          if (p === null || c(p))
            return !0;
          var b = O(p);
          if (b) {
            var y = b.call(p), _;
            if (b !== p.entries) {
              for (; !(_ = y.next()).done; )
                if (!N(_.value))
                  return !1;
            } else
              for (; !(_ = y.next()).done; ) {
                var v = _.value;
                if (v && !N(v[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Q(p, b) {
      return p === "symbol" ? !0 : b ? b["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && b instanceof Symbol : !1;
    }
    function J(p) {
      var b = typeof p;
      return Array.isArray(p) ? "array" : p instanceof RegExp ? "object" : Q(b, p) ? "symbol" : b;
    }
    function re(p) {
      if (typeof p > "u" || p === null)
        return "" + p;
      var b = J(p);
      if (b === "object") {
        if (p instanceof Date)
          return "date";
        if (p instanceof RegExp)
          return "regexp";
      }
      return b;
    }
    function oe(p) {
      var b = re(p);
      switch (b) {
        case "array":
        case "object":
          return "an " + b;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + b;
        default:
          return b;
      }
    }
    function se(p) {
      return !p.constructor || !p.constructor.name ? S : p.constructor.name;
    }
    return P.checkPropTypes = i, P.resetWarningCache = i.resetWarningCache, P.PropTypes = P, P;
  }, Xe;
}
var Je, Dt;
function Ln() {
  if (Dt) return Je;
  Dt = 1;
  var t = /* @__PURE__ */ nt();
  function n() {
  }
  function r() {
  }
  return r.resetWarningCache = n, Je = function() {
    function o(u, c, f, E, I, O) {
      if (O !== t) {
        var S = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw S.name = "Invariant Violation", S;
      }
    }
    o.isRequired = o;
    function i() {
      return o;
    }
    var e = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: i,
      element: o,
      elementType: o,
      instanceOf: i,
      node: o,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: n
    };
    return e.PropTypes = e, e;
  }, Je;
}
var Rt;
function jn() {
  if (Rt) return De.exports;
  if (Rt = 1, process.env.NODE_ENV !== "production") {
    var t = Ft(), n = !0;
    De.exports = /* @__PURE__ */ Kn()(t.isElement, n);
  } else
    De.exports = /* @__PURE__ */ Ln()();
  return De.exports;
}
var Fn = /* @__PURE__ */ jn();
const g = /* @__PURE__ */ Rn(Fn);
var Te = { exports: {} }, W = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tt;
function Bn() {
  if (Tt) return W;
  Tt = 1;
  var t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), e = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.server_context"), f = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), I = Symbol.for("react.suspense_list"), O = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), P = Symbol.for("react.offscreen"), k;
  k = Symbol.for("react.module.reference");
  function C(h) {
    if (typeof h == "object" && h !== null) {
      var q = h.$$typeof;
      switch (q) {
        case t:
          switch (h = h.type, h) {
            case r:
            case i:
            case o:
            case E:
            case I:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case c:
                case u:
                case f:
                case S:
                case O:
                case e:
                  return h;
                default:
                  return q;
              }
          }
        case n:
          return q;
      }
    }
  }
  return W.ContextConsumer = u, W.ContextProvider = e, W.Element = t, W.ForwardRef = f, W.Fragment = r, W.Lazy = S, W.Memo = O, W.Portal = n, W.Profiler = i, W.StrictMode = o, W.Suspense = E, W.SuspenseList = I, W.isAsyncMode = function() {
    return !1;
  }, W.isConcurrentMode = function() {
    return !1;
  }, W.isContextConsumer = function(h) {
    return C(h) === u;
  }, W.isContextProvider = function(h) {
    return C(h) === e;
  }, W.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === t;
  }, W.isForwardRef = function(h) {
    return C(h) === f;
  }, W.isFragment = function(h) {
    return C(h) === r;
  }, W.isLazy = function(h) {
    return C(h) === S;
  }, W.isMemo = function(h) {
    return C(h) === O;
  }, W.isPortal = function(h) {
    return C(h) === n;
  }, W.isProfiler = function(h) {
    return C(h) === i;
  }, W.isStrictMode = function(h) {
    return C(h) === o;
  }, W.isSuspense = function(h) {
    return C(h) === E;
  }, W.isSuspenseList = function(h) {
    return C(h) === I;
  }, W.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === r || h === i || h === o || h === E || h === I || h === P || typeof h == "object" && h !== null && (h.$$typeof === S || h.$$typeof === O || h.$$typeof === e || h.$$typeof === u || h.$$typeof === f || h.$$typeof === k || h.getModuleId !== void 0);
  }, W.typeOf = C, W;
}
var z = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pt;
function qn() {
  return Pt || (Pt = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), e = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.server_context"), f = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), I = Symbol.for("react.suspense_list"), O = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), P = Symbol.for("react.offscreen"), k = !1, C = !1, h = !1, q = !1, a = !1, d;
    d = Symbol.for("react.module.reference");
    function l(x) {
      return !!(typeof x == "string" || typeof x == "function" || x === r || x === i || a || x === o || x === E || x === I || q || x === P || k || C || h || typeof x == "object" && x !== null && (x.$$typeof === S || x.$$typeof === O || x.$$typeof === e || x.$$typeof === u || x.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      x.$$typeof === d || x.getModuleId !== void 0));
    }
    function s(x) {
      if (typeof x == "object" && x !== null) {
        var le = x.$$typeof;
        switch (le) {
          case t:
            var ce = x.type;
            switch (ce) {
              case r:
              case i:
              case o:
              case E:
              case I:
                return ce;
              default:
                var me = ce && ce.$$typeof;
                switch (me) {
                  case c:
                  case u:
                  case f:
                  case S:
                  case O:
                  case e:
                    return me;
                  default:
                    return le;
                }
            }
          case n:
            return le;
        }
      }
    }
    var D = u, K = e, M = t, F = f, H = r, L = S, B = O, X = n, N = i, Q = o, J = E, re = I, oe = !1, se = !1;
    function p(x) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function b(x) {
      return se || (se = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function y(x) {
      return s(x) === u;
    }
    function _(x) {
      return s(x) === e;
    }
    function v(x) {
      return typeof x == "object" && x !== null && x.$$typeof === t;
    }
    function w(x) {
      return s(x) === f;
    }
    function R(x) {
      return s(x) === r;
    }
    function T(x) {
      return s(x) === S;
    }
    function V(x) {
      return s(x) === O;
    }
    function $(x) {
      return s(x) === n;
    }
    function A(x) {
      return s(x) === i;
    }
    function G(x) {
      return s(x) === o;
    }
    function m(x) {
      return s(x) === E;
    }
    function Z(x) {
      return s(x) === I;
    }
    z.ContextConsumer = D, z.ContextProvider = K, z.Element = M, z.ForwardRef = F, z.Fragment = H, z.Lazy = L, z.Memo = B, z.Portal = X, z.Profiler = N, z.StrictMode = Q, z.Suspense = J, z.SuspenseList = re, z.isAsyncMode = p, z.isConcurrentMode = b, z.isContextConsumer = y, z.isContextProvider = _, z.isElement = v, z.isForwardRef = w, z.isFragment = R, z.isLazy = T, z.isMemo = V, z.isPortal = $, z.isProfiler = A, z.isStrictMode = G, z.isSuspense = m, z.isSuspenseList = Z, z.isValidElementType = l, z.typeOf = s;
  }()), z;
}
var Mt;
function Yn() {
  return Mt || (Mt = 1, process.env.NODE_ENV === "production" ? Te.exports = Bn() : Te.exports = qn()), Te.exports;
}
var Nt = Yn();
const Vt = (t) => typeof t == "object" && t != null && t.nodeType === 1, At = (t, n) => (!n || t !== "hidden") && t !== "visible" && t !== "clip", Pe = (t, n) => {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    const r = getComputedStyle(t, null);
    return At(r.overflowY, n) || At(r.overflowX, n) || ((o) => {
      const i = ((e) => {
        if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
        try {
          return e.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(o);
      return !!i && (i.clientHeight < o.scrollHeight || i.clientWidth < o.scrollWidth);
    })(t);
  }
  return !1;
}, Me = (t, n, r, o, i, e, u, c) => e < t && u > n || e > t && u < n ? 0 : e <= t && c <= r || u >= n && c >= r ? e - t - o : u > n && c < r || e < t && c > r ? u - n + i : 0, Un = (t) => {
  const n = t.parentElement;
  return n ?? (t.getRootNode().host || null);
}, Wn = (t, n) => {
  var r, o, i, e;
  if (typeof document > "u") return [];
  const { inline: u, boundary: c, skipOverflowHiddenElements: f } = n, E = typeof c == "function" ? c : (X) => X !== c;
  if (!Vt(t)) throw new TypeError("Invalid target");
  const I = document.scrollingElement || document.documentElement, O = [];
  let S = t;
  for (; Vt(S) && E(S); ) {
    if (S = Un(S), S === I) {
      O.push(S);
      break;
    }
    S != null && S === document.body && Pe(S) && !Pe(document.documentElement) || S != null && Pe(S, f) && O.push(S);
  }
  const P = (o = (r = window.visualViewport) == null ? void 0 : r.width) != null ? o : innerWidth, k = (e = (i = window.visualViewport) == null ? void 0 : i.height) != null ? e : innerHeight, { scrollX: C, scrollY: h } = window, { height: q, width: a, top: d, right: l, bottom: s, left: D } = t.getBoundingClientRect(), { top: K, right: M, left: F } = ((X) => {
    const N = window.getComputedStyle(X);
    return { top: parseFloat(N.scrollMarginTop) || 0, right: parseFloat(N.scrollMarginRight) || 0, bottom: parseFloat(N.scrollMarginBottom) || 0, left: parseFloat(N.scrollMarginLeft) || 0 };
  })(t);
  let H = d - K, L = u === "center" ? D + a / 2 - F + M : u === "end" ? l + M : D - F;
  const B = [];
  for (let X = 0; X < O.length; X++) {
    const N = O[X], { height: Q, width: J, top: re, right: oe, bottom: se, left: p } = N.getBoundingClientRect();
    if (d >= 0 && D >= 0 && s <= k && l <= P && (N === I && !Pe(N) || d >= re && s <= se && D >= p && l <= oe)) return B;
    const b = getComputedStyle(N), y = parseInt(b.borderLeftWidth, 10), _ = parseInt(b.borderTopWidth, 10), v = parseInt(b.borderRightWidth, 10), w = parseInt(b.borderBottomWidth, 10);
    let R = 0, T = 0;
    const V = "offsetWidth" in N ? N.offsetWidth - N.clientWidth - y - v : 0, $ = "offsetHeight" in N ? N.offsetHeight - N.clientHeight - _ - w : 0, A = "offsetWidth" in N ? N.offsetWidth === 0 ? 0 : J / N.offsetWidth : 0, G = "offsetHeight" in N ? N.offsetHeight === 0 ? 0 : Q / N.offsetHeight : 0;
    if (I === N) R = Me(h, h + k, k, _, w, h + H, h + H + q, q), T = u === "start" ? L : u === "center" ? L - P / 2 : u === "end" ? L - P : Me(C, C + P, P, y, v, C + L, C + L + a, a), R = Math.max(0, R + h), T = Math.max(0, T + C);
    else {
      R = Me(re, se, Q, _, w + $, H, H + q, q), T = u === "start" ? L - p - y : u === "center" ? L - (p + J / 2) + V / 2 : u === "end" ? L - oe + v + V : Me(p, oe, J, y, v + V, L, L + a, a);
      const { scrollLeft: m, scrollTop: Z } = N;
      R = G === 0 ? 0 : Math.max(0, Math.min(Z + R / G, N.scrollHeight - Q / G + $)), T = A === 0 ? 0 : Math.max(0, Math.min(m + T / A, N.scrollWidth - J / A + V)), H += Z - R, L += m - T;
    }
    B.push({ el: N, top: R, left: T });
  }
  return B;
};
var zn = 0;
function kt(t) {
  return typeof t == "function" ? t : ie;
}
function ie() {
}
function qt(t, n) {
  if (t) {
    var r = Wn(t, {
      boundary: n
    });
    r.forEach(function(o) {
      var i = o.el, e = o.top, u = o.left;
      i.scrollTop = e, i.scrollLeft = u;
    });
  }
}
function Ht(t, n, r) {
  var o = t === n || n instanceof r.Node && t.contains && t.contains(n);
  return o;
}
function rt(t, n) {
  var r;
  function o() {
    r && clearTimeout(r);
  }
  function i() {
    for (var e = arguments.length, u = new Array(e), c = 0; c < e; c++)
      u[c] = arguments[c];
    o(), r = setTimeout(function() {
      r = null, t.apply(void 0, u);
    }, n);
  }
  return i.cancel = o, i;
}
function ee() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return function(o) {
    for (var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), u = 1; u < i; u++)
      e[u - 1] = arguments[u];
    return n.some(function(c) {
      return c && c.apply(void 0, [o].concat(e)), o.preventDownshiftDefault || o.hasOwnProperty("nativeEvent") && o.nativeEvent.preventDownshiftDefault;
    });
  };
}
function ye() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return function(o) {
    n.forEach(function(i) {
      typeof i == "function" ? i(o) : i && (i.current = o);
    });
  };
}
function Yt() {
  return String(zn++);
}
function Gn(t) {
  var n = t.isOpen, r = t.resultCount, o = t.previousResultCount;
  return n ? r ? r !== o ? r + " result" + (r === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function $t(t, n) {
  return t = Array.isArray(t) ? (
    /* istanbul ignore next (preact) */
    t[0]
  ) : t, !t && n ? n : t;
}
function Ut(t) {
  return typeof t.type == "string";
}
function Wt(t) {
  return t.props;
}
function Xn(t, n) {
  console.error('The property "' + n + '" is required in "' + t + '"');
}
var Jn = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function Ne(t) {
  t === void 0 && (t = {});
  var n = {};
  return Jn.forEach(function(r) {
    t.hasOwnProperty(r) && (n[r] = t[r]);
  }), n;
}
function Ke(t, n) {
  return !t || !n ? t : Object.keys(t).reduce(function(r, o) {
    return r[o] = Le(n, o) ? n[o] : t[o], r;
  }, {});
}
function Le(t, n) {
  return t[n] !== void 0;
}
function Qe(t) {
  var n = t.key, r = t.keyCode;
  return r >= 37 && r <= 40 && n.indexOf("Arrow") !== 0 ? "Arrow" + n : n;
}
function Zn(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Ie(t, n, r, o, i) {
  var e = r.length;
  if (e === 0)
    return -1;
  var u = e - 1;
  (typeof t != "number" || t < 0 || t > u) && (t = n > 0 ? -1 : u + 1);
  var c = t + n;
  c < 0 ? c = u : c > u && (c = 0);
  var f = Ee(c, n < 0, r, o, i);
  return f === -1 ? t >= e ? -1 : t : f;
}
function Ee(t, n, r, o, i) {
  i === void 0 && (i = !1);
  var e = r.length;
  if (n) {
    for (var u = t; u >= 0; u--)
      if (!o(r[u], u))
        return u;
  } else
    for (var c = t; c < e; c++)
      if (!o(r[c], c))
        return c;
  return i ? Ee(n ? e - 1 : 0, n, r, o) : -1;
}
function je(t, n, r, o) {
  return o === void 0 && (o = !0), r && n.some(function(i) {
    return i && (Ht(i, t, r) || o && Ht(i, r.document.activeElement, r));
  });
}
var ot = ie;
process.env.NODE_ENV !== "production" && (ot = function(n, r, o) {
  var i = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(n).forEach(function(e) {
    r[e] !== void 0 && o[e] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + e + '" to be uncontrolled. ' + i) : r[e] === void 0 && o[e] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + e + '" to be controlled. ' + i);
  });
});
var Qn = rt(function(t) {
  zt(t).textContent = "";
}, 500);
function zt(t) {
  var n = t.getElementById("a11y-status-message");
  return n || (n = t.createElement("div"), n.setAttribute("id", "a11y-status-message"), n.setAttribute("role", "status"), n.setAttribute("aria-live", "polite"), n.setAttribute("aria-relevant", "additions text"), Object.assign(n.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), t.body.appendChild(n), n);
}
function Gt(t, n) {
  if (!(!t || !n)) {
    var r = zt(n);
    r.textContent = t, Qn(n);
  }
}
function er(t) {
  var n = t == null ? void 0 : t.getElementById("a11y-status-message");
  n && n.remove();
}
var Xt = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, Jt = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, Zt = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Ve = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, Ae = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Qt = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, en = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, tn = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, nn = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, rn = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, on = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, un = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, sn = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, et = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, an = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, ln = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, cn = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, tr = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blurButton: an,
  blurInput: on,
  changeInput: un,
  clickButton: et,
  clickItem: rn,
  controlledPropUpdatedSelectedItem: ln,
  itemMouseEnter: Zt,
  keyDownArrowDown: Ae,
  keyDownArrowUp: Ve,
  keyDownEnd: nn,
  keyDownEnter: en,
  keyDownEscape: Qt,
  keyDownHome: tn,
  keyDownSpaceButton: sn,
  mouseUp: Jt,
  touchEnd: cn,
  unknown: Xt
}), nr = ["refKey", "ref"], rr = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], or = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], ir = ["refKey", "ref"], ur = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], sr = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ function(n) {
    function r(i) {
      var e;
      e = n.call(this, i) || this, e.id = e.props.id || "downshift-" + Yt(), e.menuId = e.props.menuId || e.id + "-menu", e.labelId = e.props.labelId || e.id + "-label", e.inputId = e.props.inputId || e.id + "-input", e.getItemId = e.props.getItemId || function(a) {
        return e.id + "-item-" + a;
      }, e.items = [], e.itemCount = null, e.previousResultCount = 0, e.timeoutIds = [], e.internalSetTimeout = function(a, d) {
        var l = setTimeout(function() {
          e.timeoutIds = e.timeoutIds.filter(function(s) {
            return s !== l;
          }), a();
        }, d);
        e.timeoutIds.push(l);
      }, e.setItemCount = function(a) {
        e.itemCount = a;
      }, e.unsetItemCount = function() {
        e.itemCount = null;
      }, e.isItemDisabled = function(a, d) {
        var l = e.getItemNodeFromIndex(d);
        return l && l.hasAttribute("disabled");
      }, e.setHighlightedIndex = function(a, d) {
        a === void 0 && (a = e.props.defaultHighlightedIndex), d === void 0 && (d = {}), d = Ne(d), e.internalSetState(j({
          highlightedIndex: a
        }, d));
      }, e.clearSelection = function(a) {
        e.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: e.props.defaultHighlightedIndex,
          isOpen: e.props.defaultIsOpen
        }, a);
      }, e.selectItem = function(a, d, l) {
        d = Ne(d), e.internalSetState(j({
          isOpen: e.props.defaultIsOpen,
          highlightedIndex: e.props.defaultHighlightedIndex,
          selectedItem: a,
          inputValue: e.props.itemToString(a)
        }, d), l);
      }, e.selectItemAtIndex = function(a, d, l) {
        var s = e.items[a];
        s != null && e.selectItem(s, d, l);
      }, e.selectHighlightedItem = function(a, d) {
        return e.selectItemAtIndex(e.getState().highlightedIndex, a, d);
      }, e.internalSetState = function(a, d) {
        var l, s, D = {}, K = typeof a == "function";
        return !K && a.hasOwnProperty("inputValue") && e.props.onInputValueChange(a.inputValue, j({}, e.getStateAndHelpers(), a)), e.setState(function(M) {
          var F;
          M = e.getState(M);
          var H = K ? a(M) : a;
          H = e.props.stateReducer(M, H), l = H.hasOwnProperty("selectedItem");
          var L = {};
          return l && H.selectedItem !== M.selectedItem && (s = H.selectedItem), (F = H).type || (F.type = Xt), Object.keys(H).forEach(function(B) {
            M[B] !== H[B] && (D[B] = H[B]), B !== "type" && (H[B], Le(e.props, B) || (L[B] = H[B]));
          }), K && H.hasOwnProperty("inputValue") && e.props.onInputValueChange(H.inputValue, j({}, e.getStateAndHelpers(), H)), L;
        }, function() {
          kt(d)();
          var M = Object.keys(D).length > 1;
          M && e.props.onStateChange(D, e.getStateAndHelpers()), l && e.props.onSelect(a.selectedItem, e.getStateAndHelpers()), s !== void 0 && e.props.onChange(s, e.getStateAndHelpers()), e.props.onUserAction(D, e.getStateAndHelpers());
        });
      }, e.rootRef = function(a) {
        return e._rootNode = a;
      }, e.getRootProps = function(a, d) {
        var l, s = a === void 0 ? {} : a, D = s.refKey, K = D === void 0 ? "ref" : D, M = s.ref, F = pe(s, nr), H = d === void 0 ? {} : d, L = H.suppressRefError, B = L === void 0 ? !1 : L;
        e.getRootProps.called = !0, e.getRootProps.refKey = K, e.getRootProps.suppressRefError = B;
        var X = e.getState(), N = X.isOpen;
        return j((l = {}, l[K] = ye(M, e.rootRef), l.role = "combobox", l["aria-expanded"] = N, l["aria-haspopup"] = "listbox", l["aria-owns"] = N ? e.menuId : void 0, l["aria-labelledby"] = e.labelId, l), F);
      }, e.keyDownHandlers = {
        ArrowDown: function(d) {
          var l = this;
          if (d.preventDefault(), this.getState().isOpen) {
            var s = d.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(s, {
              type: Ae
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Ae
            }, function() {
              var D = l.getItemCount();
              if (D > 0) {
                var K = l.getState(), M = K.highlightedIndex, F = Ie(M, 1, {
                  length: D
                }, l.isItemDisabled, !0);
                l.setHighlightedIndex(F, {
                  type: Ae
                });
              }
            });
        },
        ArrowUp: function(d) {
          var l = this;
          if (d.preventDefault(), this.getState().isOpen) {
            var s = d.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(s, {
              type: Ve
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Ve
            }, function() {
              var D = l.getItemCount();
              if (D > 0) {
                var K = l.getState(), M = K.highlightedIndex, F = Ie(M, -1, {
                  length: D
                }, l.isItemDisabled, !0);
                l.setHighlightedIndex(F, {
                  type: Ve
                });
              }
            });
        },
        Enter: function(d) {
          if (d.which !== 229) {
            var l = this.getState(), s = l.isOpen, D = l.highlightedIndex;
            if (s && D != null) {
              d.preventDefault();
              var K = this.items[D], M = this.getItemNodeFromIndex(D);
              if (K == null || M && M.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: en
              });
            }
          }
        },
        Escape: function(d) {
          d.preventDefault(), this.reset(j({
            type: Qt
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, e.buttonKeyDownHandlers = j({}, e.keyDownHandlers, {
        " ": function(d) {
          d.preventDefault(), this.toggleMenu({
            type: sn
          });
        }
      }), e.inputKeyDownHandlers = j({}, e.keyDownHandlers, {
        Home: function(d) {
          var l = this.getState(), s = l.isOpen;
          if (s) {
            d.preventDefault();
            var D = this.getItemCount();
            if (!(D <= 0 || !s)) {
              var K = Ee(0, !1, {
                length: D
              }, this.isItemDisabled);
              this.setHighlightedIndex(K, {
                type: tn
              });
            }
          }
        },
        End: function(d) {
          var l = this.getState(), s = l.isOpen;
          if (s) {
            d.preventDefault();
            var D = this.getItemCount();
            if (!(D <= 0 || !s)) {
              var K = Ee(D - 1, !0, {
                length: D
              }, this.isItemDisabled);
              this.setHighlightedIndex(K, {
                type: nn
              });
            }
          }
        }
      }), e.getToggleButtonProps = function(a) {
        var d = a === void 0 ? {} : a, l = d.onClick;
        d.onPress;
        var s = d.onKeyDown, D = d.onKeyUp, K = d.onBlur, M = pe(d, rr), F = e.getState(), H = F.isOpen, L = {
          onClick: ee(l, e.buttonHandleClick),
          onKeyDown: ee(s, e.buttonHandleKeyDown),
          onKeyUp: ee(D, e.buttonHandleKeyUp),
          onBlur: ee(K, e.buttonHandleBlur)
        }, B = M.disabled ? {} : L;
        return j({
          type: "button",
          role: "button",
          "aria-label": H ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, B, M);
      }, e.buttonHandleKeyUp = function(a) {
        a.preventDefault();
      }, e.buttonHandleKeyDown = function(a) {
        var d = Qe(a);
        e.buttonKeyDownHandlers[d] && e.buttonKeyDownHandlers[d].call(e, a);
      }, e.buttonHandleClick = function(a) {
        if (a.preventDefault(), e.props.environment) {
          var d = e.props.environment.document, l = d.body, s = d.activeElement;
          l && l === s && a.target.focus();
        }
        process.env.NODE_ENV === "test" ? e.toggleMenu({
          type: et
        }) : e.internalSetTimeout(function() {
          return e.toggleMenu({
            type: et
          });
        });
      }, e.buttonHandleBlur = function(a) {
        var d = a.target;
        e.internalSetTimeout(function() {
          if (!(e.isMouseDown || !e.props.environment)) {
            var l = e.props.environment.document.activeElement;
            (l == null || l.id !== e.inputId) && l !== d && e.reset({
              type: an
            });
          }
        });
      }, e.getLabelProps = function(a) {
        return j({
          htmlFor: e.inputId,
          id: e.labelId
        }, a);
      }, e.getInputProps = function(a) {
        var d = a === void 0 ? {} : a, l = d.onKeyDown, s = d.onBlur, D = d.onChange, K = d.onInput;
        d.onChangeText;
        var M = pe(d, or), F, H = {};
        F = "onChange";
        var L = e.getState(), B = L.inputValue, X = L.isOpen, N = L.highlightedIndex;
        if (!M.disabled) {
          var Q;
          H = (Q = {}, Q[F] = ee(D, K, e.inputHandleChange), Q.onKeyDown = ee(l, e.inputHandleKeyDown), Q.onBlur = ee(s, e.inputHandleBlur), Q);
        }
        return j({
          "aria-autocomplete": "list",
          "aria-activedescendant": X && typeof N == "number" && N >= 0 ? e.getItemId(N) : void 0,
          "aria-controls": X ? e.menuId : void 0,
          "aria-labelledby": M && M["aria-label"] ? void 0 : e.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: B,
          id: e.inputId
        }, H, M);
      }, e.inputHandleKeyDown = function(a) {
        var d = Qe(a);
        d && e.inputKeyDownHandlers[d] && e.inputKeyDownHandlers[d].call(e, a);
      }, e.inputHandleChange = function(a) {
        e.internalSetState({
          type: un,
          isOpen: !0,
          inputValue: a.target.value,
          highlightedIndex: e.props.defaultHighlightedIndex
        });
      }, e.inputHandleBlur = function() {
        e.internalSetTimeout(function() {
          var a;
          if (!(e.isMouseDown || !e.props.environment)) {
            var d = e.props.environment.document.activeElement, l = (d == null || (a = d.dataset) == null ? void 0 : a.toggle) && e._rootNode && e._rootNode.contains(d);
            l || e.reset({
              type: on
            });
          }
        });
      }, e.menuRef = function(a) {
        e._menuNode = a;
      }, e.getMenuProps = function(a, d) {
        var l, s = a === void 0 ? {} : a, D = s.refKey, K = D === void 0 ? "ref" : D, M = s.ref, F = pe(s, ir), H = d === void 0 ? {} : d, L = H.suppressRefError, B = L === void 0 ? !1 : L;
        return e.getMenuProps.called = !0, e.getMenuProps.refKey = K, e.getMenuProps.suppressRefError = B, j((l = {}, l[K] = ye(M, e.menuRef), l.role = "listbox", l["aria-labelledby"] = F && F["aria-label"] ? void 0 : e.labelId, l.id = e.menuId, l), F);
      }, e.getItemProps = function(a) {
        var d, l = a === void 0 ? {} : a, s = l.onMouseMove, D = l.onMouseDown, K = l.onClick;
        l.onPress;
        var M = l.index, F = l.item, H = F === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : Xn("getItemProps", "item") : F, L = pe(l, ur);
        M === void 0 ? (e.items.push(H), M = e.items.indexOf(H)) : e.items[M] = H;
        var B = "onClick", X = K, N = (d = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: ee(s, function() {
            M !== e.getState().highlightedIndex && (e.setHighlightedIndex(M, {
              type: Zt
            }), e.avoidScrolling = !0, e.internalSetTimeout(function() {
              return e.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: ee(D, function(J) {
            J.preventDefault();
          })
        }, d[B] = ee(X, function() {
          e.selectItemAtIndex(M, {
            type: rn
          });
        }), d), Q = L.disabled ? {
          onMouseDown: N.onMouseDown
        } : N;
        return j({
          id: e.getItemId(M),
          role: "option",
          "aria-selected": e.getState().highlightedIndex === M
        }, Q, L);
      }, e.clearItems = function() {
        e.items = [];
      }, e.reset = function(a, d) {
        a === void 0 && (a = {}), a = Ne(a), e.internalSetState(function(l) {
          var s = l.selectedItem;
          return j({
            isOpen: e.props.defaultIsOpen,
            highlightedIndex: e.props.defaultHighlightedIndex,
            inputValue: e.props.itemToString(s)
          }, a);
        }, d);
      }, e.toggleMenu = function(a, d) {
        a === void 0 && (a = {}), a = Ne(a), e.internalSetState(function(l) {
          var s = l.isOpen;
          return j({
            isOpen: !s
          }, s && {
            highlightedIndex: e.props.defaultHighlightedIndex
          }, a);
        }, function() {
          var l = e.getState(), s = l.isOpen, D = l.highlightedIndex;
          s && e.getItemCount() > 0 && typeof D == "number" && e.setHighlightedIndex(D, a), kt(d)();
        });
      }, e.openMenu = function(a) {
        e.internalSetState({
          isOpen: !0
        }, a);
      }, e.closeMenu = function(a) {
        e.internalSetState({
          isOpen: !1
        }, a);
      }, e.updateStatus = rt(function() {
        var a;
        if ((a = e.props) != null && (a = a.environment) != null && a.document) {
          var d = e.getState(), l = e.items[d.highlightedIndex], s = e.getItemCount(), D = e.props.getA11yStatusMessage(j({
            itemToString: e.props.itemToString,
            previousResultCount: e.previousResultCount,
            resultCount: s,
            highlightedItem: l
          }, d));
          e.previousResultCount = s, Gt(D, e.props.environment.document);
        }
      }, 200);
      var u = e.props, c = u.defaultHighlightedIndex, f = u.initialHighlightedIndex, E = f === void 0 ? c : f, I = u.defaultIsOpen, O = u.initialIsOpen, S = O === void 0 ? I : O, P = u.initialInputValue, k = P === void 0 ? "" : P, C = u.initialSelectedItem, h = C === void 0 ? null : C, q = e.getState({
        highlightedIndex: E,
        isOpen: S,
        inputValue: k,
        selectedItem: h
      });
      return q.selectedItem != null && e.props.initialInputValue === void 0 && (q.inputValue = e.props.itemToString(q.selectedItem)), e.state = q, e;
    }
    Vn(r, n);
    var o = r.prototype;
    return o.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(e) {
        clearTimeout(e);
      }), this.timeoutIds = [];
    }, o.getState = function(e) {
      return e === void 0 && (e = this.state), Ke(e, this.props);
    }, o.getItemCount = function() {
      var e = this.items.length;
      return this.itemCount != null ? e = this.itemCount : this.props.itemCount !== void 0 && (e = this.props.itemCount), e;
    }, o.getItemNodeFromIndex = function(e) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(e)) : null;
    }, o.scrollHighlightedItemIntoView = function() {
      {
        var e = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(e, this._menuNode);
      }
    }, o.moveHighlightedIndex = function(e, u) {
      var c = this.getItemCount(), f = this.getState(), E = f.highlightedIndex;
      if (c > 0) {
        var I = Ie(E, e, {
          length: c
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(I, u);
      }
    }, o.getStateAndHelpers = function() {
      var e = this.getState(), u = e.highlightedIndex, c = e.inputValue, f = e.selectedItem, E = e.isOpen, I = this.props.itemToString, O = this.id, S = this.getRootProps, P = this.getToggleButtonProps, k = this.getLabelProps, C = this.getMenuProps, h = this.getInputProps, q = this.getItemProps, a = this.openMenu, d = this.closeMenu, l = this.toggleMenu, s = this.selectItem, D = this.selectItemAtIndex, K = this.selectHighlightedItem, M = this.setHighlightedIndex, F = this.clearSelection, H = this.clearItems, L = this.reset, B = this.setItemCount, X = this.unsetItemCount, N = this.internalSetState;
      return {
        // prop getters
        getRootProps: S,
        getToggleButtonProps: P,
        getLabelProps: k,
        getMenuProps: C,
        getInputProps: h,
        getItemProps: q,
        // actions
        reset: L,
        openMenu: a,
        closeMenu: d,
        toggleMenu: l,
        selectItem: s,
        selectItemAtIndex: D,
        selectHighlightedItem: K,
        setHighlightedIndex: M,
        clearSelection: F,
        clearItems: H,
        setItemCount: B,
        unsetItemCount: X,
        setState: N,
        // props
        itemToString: I,
        // derived
        id: O,
        // state
        highlightedIndex: u,
        inputValue: c,
        isOpen: E,
        selectedItem: f
      };
    }, o.componentDidMount = function() {
      var e = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && Kt(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          e.internalClearTimeouts();
        };
      else {
        var u = function() {
          e.isMouseDown = !0;
        }, c = function(P) {
          e.isMouseDown = !1;
          var k = je(P.target, [e._rootNode, e._menuNode], e.props.environment);
          !k && e.getState().isOpen && e.reset({
            type: Jt
          }, function() {
            return e.props.onOuterClick(e.getStateAndHelpers());
          });
        }, f = function() {
          e.isTouchMove = !1;
        }, E = function() {
          e.isTouchMove = !0;
        }, I = function(P) {
          var k = je(P.target, [e._rootNode, e._menuNode], e.props.environment, !1);
          !e.isTouchMove && !k && e.getState().isOpen && e.reset({
            type: cn
          }, function() {
            return e.props.onOuterClick(e.getStateAndHelpers());
          });
        }, O = this.props.environment;
        O.addEventListener("mousedown", u), O.addEventListener("mouseup", c), O.addEventListener("touchstart", f), O.addEventListener("touchmove", E), O.addEventListener("touchend", I), this.cleanup = function() {
          e.internalClearTimeouts(), e.updateStatus.cancel(), O.removeEventListener("mousedown", u), O.removeEventListener("mouseup", c), O.removeEventListener("touchstart", f), O.removeEventListener("touchmove", E), O.removeEventListener("touchend", I);
        };
      }
    }, o.shouldScroll = function(e, u) {
      var c = this.props.highlightedIndex === void 0 ? this.getState() : this.props, f = c.highlightedIndex, E = u.highlightedIndex === void 0 ? e : u, I = E.highlightedIndex, O = f && this.getState().isOpen && !e.isOpen, S = f !== I;
      return O || S;
    }, o.componentDidUpdate = function(e, u) {
      process.env.NODE_ENV !== "production" && (ot(this.state, e, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && Kt(this._menuNode, this.getMenuProps)), Le(this.props, "selectedItem") && this.props.selectedItemChanged(e.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: ln,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(u, e) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, o.componentWillUnmount = function() {
      this.cleanup();
    }, o.render = function() {
      var e = $t(this.props.children, ie);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var u = $t(e(this.getStateAndHelpers()));
      if (!u)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && ar(u, this.getRootProps), u;
      if (Ut(u))
        return /* @__PURE__ */ Mn(u, this.getRootProps(Wt(u)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, r;
  }(Nn);
  return t.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: Gn,
    itemToString: function(r) {
      return r == null ? "" : (process.env.NODE_ENV !== "production" && Zn(r) && !r.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", r), String(r));
    },
    onStateChange: ie,
    onInputValueChange: ie,
    onUserAction: ie,
    onChange: ie,
    onSelect: ie,
    onOuterClick: ie,
    selectedItemChanged: function(r, o) {
      return r !== o;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(r, o) {
      return o;
    },
    suppressRefError: !1,
    scrollIntoView: qt
  }, t.stateChangeTypes = tr, t;
}();
process.env.NODE_ENV !== "production" && (sr.propTypes = {
  children: g.func,
  defaultHighlightedIndex: g.number,
  defaultIsOpen: g.bool,
  initialHighlightedIndex: g.number,
  initialSelectedItem: g.any,
  initialInputValue: g.string,
  initialIsOpen: g.bool,
  getA11yStatusMessage: g.func,
  itemToString: g.func,
  onChange: g.func,
  onSelect: g.func,
  onStateChange: g.func,
  onInputValueChange: g.func,
  onUserAction: g.func,
  onOuterClick: g.func,
  selectedItemChanged: g.func,
  stateReducer: g.func,
  itemCount: g.number,
  id: g.string,
  environment: g.shape({
    addEventListener: g.func.isRequired,
    removeEventListener: g.func.isRequired,
    document: g.shape({
      createElement: g.func.isRequired,
      getElementById: g.func.isRequired,
      activeElement: g.any.isRequired,
      body: g.any.isRequired
    }).isRequired,
    Node: g.func.isRequired
  }),
  suppressRefError: g.bool,
  scrollIntoView: g.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: g.any,
  isOpen: g.bool,
  inputValue: g.string,
  highlightedIndex: g.number,
  labelId: g.string,
  inputId: g.string,
  menuId: g.string,
  getItemId: g.func
  /* eslint-enable react/no-unused-prop-types */
});
function Kt(t, n) {
  var r = n.refKey;
  t || console.error('downshift: The ref prop "' + r + '" from getMenuProps was not applied correctly on your menu element.');
}
function ar(t, n) {
  var r = n.refKey, o = r !== "ref", i = !Ut(t);
  i && !o && !Nt.isForwardRef(t) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !i && o && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + r + '"'), !Nt.isForwardRef(t) && !Wt(t)[r] && console.error('downshift: You must apply the ref prop "' + r + '" from getRootProps onto your root element.');
}
var dn = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function lr(t, n, r) {
  var o = t.props, i = t.type, e = {};
  Object.keys(n).forEach(function(u) {
    cr(u, t, n, r), r[u] !== n[u] && (e[u] = r[u]);
  }), o.onStateChange && Object.keys(e).length && o.onStateChange(j({
    type: i
  }, e));
}
function cr(t, n, r, o) {
  var i = n.props, e = n.type, u = "on" + it(t) + "Change";
  i[u] && o[t] !== void 0 && o[t] !== r[t] && i[u](j({
    type: e
  }, o));
}
function dr(t, n) {
  return n.changes;
}
var Lt = rt(function(t, n) {
  Gt(t, n);
}, 200), fr = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Tn : ue, pr = "useId" in He ? function(n) {
  var r = n.id, o = n.labelId, i = n.menuId, e = n.getItemId, u = n.toggleButtonId, c = n.inputId, f = "downshift-" + He.useId();
  r || (r = f);
  var E = ne({
    labelId: o || r + "-label",
    menuId: i || r + "-menu",
    getItemId: e || function(I) {
      return r + "-item-" + I;
    },
    toggleButtonId: u || r + "-toggle-button",
    inputId: c || r + "-input"
  });
  return E.current;
} : function(n) {
  var r = n.id, o = r === void 0 ? "downshift-" + Yt() : r, i = n.labelId, e = n.menuId, u = n.getItemId, c = n.toggleButtonId, f = n.inputId, E = ne({
    labelId: i || o + "-label",
    menuId: e || o + "-menu",
    getItemId: u || function(I) {
      return o + "-item-" + I;
    },
    toggleButtonId: c || o + "-toggle-button",
    inputId: f || o + "-input"
  });
  return E.current;
};
function hr(t, n, r, o) {
  var i, e;
  if (t === void 0) {
    if (n === void 0)
      throw new Error(o);
    i = r[n], e = n;
  } else
    e = n === void 0 ? r.indexOf(t) : n, i = t;
  return [i, e];
}
function it(t) {
  return "" + t.slice(0, 1).toUpperCase() + t.slice(1);
}
function fn(t) {
  var n = ne(t);
  return n.current = t, n;
}
function gr(t, n, r, o) {
  var i = ne(), e = ne(), u = te(function(P, k) {
    e.current = k, P = Ke(P, k.props);
    var C = t(P, k), h = k.props.stateReducer(P, j({}, k, {
      changes: C
    }));
    return h;
  }, [t]), c = Pn(u, n, r), f = c[0], E = c[1], I = fn(n), O = te(function(P) {
    return E(j({
      props: I.current
    }, P));
  }, [I]), S = e.current;
  return ue(function() {
    var P = Ke(i.current, S == null ? void 0 : S.props), k = S && i.current && !o(P, f);
    k && lr(S, P, f), i.current = f;
  }, [f, S, o]), [f, O];
}
var we = {
  itemToString: function(n) {
    return n ? String(n) : "";
  },
  itemToKey: function(n) {
    return n;
  },
  stateReducer: dr,
  scrollIntoView: qt,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function ve(t, n, r) {
  r === void 0 && (r = dn);
  var o = t["default" + it(n)];
  return o !== void 0 ? o : r[n];
}
function Oe(t, n, r) {
  r === void 0 && (r = dn);
  var o = t[n];
  if (o !== void 0)
    return o;
  var i = t["initial" + it(n)];
  return i !== void 0 ? i : ve(t, n, r);
}
function vr(t) {
  var n = Oe(t, "selectedItem"), r = Oe(t, "isOpen"), o = Er(t), i = Oe(t, "inputValue");
  return {
    highlightedIndex: o < 0 && n && r ? t.items.findIndex(function(e) {
      return t.itemToKey(e) === t.itemToKey(n);
    }) : o,
    isOpen: r,
    selectedItem: n,
    inputValue: i
  };
}
function xe(t, n, r) {
  var o = t.items, i = t.initialHighlightedIndex, e = t.defaultHighlightedIndex, u = t.isItemDisabled, c = t.itemToKey, f = n.selectedItem, E = n.highlightedIndex;
  return o.length === 0 ? -1 : i !== void 0 && E === i && !u(o[i], i) ? i : e !== void 0 && !u(o[e], e) ? e : f ? o.findIndex(function(I) {
    return c(f) === c(I);
  }) : r < 0 && !u(o[o.length - 1], o.length - 1) ? o.length - 1 : r > 0 && !u(o[0], 0) ? 0 : -1;
}
function mr(t, n, r) {
  var o = ne({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return ue(function() {
    if (!t)
      return ie;
    var i = r.map(function(I) {
      return I.current;
    });
    function e() {
      o.current.isTouchEnd = !1, o.current.isMouseDown = !0;
    }
    function u(I) {
      o.current.isMouseDown = !1, je(I.target, i, t) || n();
    }
    function c() {
      o.current.isTouchEnd = !1, o.current.isTouchMove = !1;
    }
    function f() {
      o.current.isTouchMove = !0;
    }
    function E(I) {
      o.current.isTouchEnd = !0, !o.current.isTouchMove && !je(I.target, i, t, !1) && n();
    }
    return t.addEventListener("mousedown", e), t.addEventListener("mouseup", u), t.addEventListener("touchstart", c), t.addEventListener("touchmove", f), t.addEventListener("touchend", E), function() {
      t.removeEventListener("mousedown", e), t.removeEventListener("mouseup", u), t.removeEventListener("touchstart", c), t.removeEventListener("touchmove", f), t.removeEventListener("touchend", E);
    };
  }, [r, t, n]), o.current;
}
var pn = function() {
  return ie;
};
process.env.NODE_ENV !== "production" && (pn = function() {
  for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  var i = ne(r.reduce(function(u, c) {
    return u[c] = {}, u;
  }, {}));
  ue(function() {
    Object.keys(i.current).forEach(function(u) {
      var c = i.current[u];
      if (!Object.keys(c).length) {
        console.error("downshift: You forgot to call the " + u + " getter function on your component / element.");
        return;
      }
      var f = c.suppressRefError, E = c.refKey, I = c.elementRef;
      f || I != null && I.current || console.error('downshift: The ref prop "' + E + '" from ' + u + " was not applied correctly on your element.");
    });
  }, []);
  var e = te(function(u, c, f, E) {
    i.current[u] = {
      suppressRefError: c,
      refKey: f,
      elementRef: E
    };
  }, []);
  return e;
});
function _r(t, n, r, o) {
  o === void 0 && (o = {});
  var i = o.document, e = Be();
  ue(function() {
    if (!(!t || e || !i)) {
      var u = t(n);
      Lt(u, i);
    }
  }, r), ue(function() {
    return function() {
      Lt.cancel(), er(i);
    };
  }, [i]);
}
function Ir(t) {
  var n = t.highlightedIndex, r = t.isOpen, o = t.itemRefs, i = t.getItemNodeFromIndex, e = t.menuElement, u = t.scrollIntoView, c = ne(!0);
  return fr(function() {
    n < 0 || !r || !Object.keys(o.current).length || (c.current === !1 ? c.current = !0 : u(i(n), e));
  }, [n]), c;
}
var hn = ie;
process.env.NODE_ENV !== "production" && (hn = function(n) {
  var r = n.props, o = n.state, i = ne(r), e = Be();
  ue(function() {
    e || (ot(o, i.current, r), i.current = r);
  }, [o, r, e]);
});
function jt(t, n, r) {
  var o;
  r === void 0 && (r = !0);
  var i = ((o = t.items) == null ? void 0 : o.length) && n >= 0;
  return j({
    isOpen: !1,
    highlightedIndex: -1
  }, i && j({
    selectedItem: t.items[n],
    isOpen: ve(t, "isOpen"),
    highlightedIndex: ve(t, "highlightedIndex")
  }, r && {
    inputValue: t.itemToString(t.items[n])
  }));
}
function yr(t, n) {
  return t.isOpen === n.isOpen && t.inputValue === n.inputValue && t.highlightedIndex === n.highlightedIndex && t.selectedItem === n.selectedItem;
}
function Be() {
  var t = He.useRef(!0);
  return He.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []), t.current;
}
function tt(t) {
  var n = ve(t, "highlightedIndex");
  return n > -1 && t.isItemDisabled(t.items[n], n) ? -1 : n;
}
function Er(t) {
  var n = Oe(t, "highlightedIndex");
  return n > -1 && t.isItemDisabled(t.items[n], n) ? -1 : n;
}
var ke = {
  environment: g.shape({
    addEventListener: g.func.isRequired,
    removeEventListener: g.func.isRequired,
    document: g.shape({
      createElement: g.func.isRequired,
      getElementById: g.func.isRequired,
      activeElement: g.any.isRequired,
      body: g.any.isRequired
    }).isRequired,
    Node: g.func.isRequired
  }),
  itemToString: g.func,
  itemToKey: g.func,
  stateReducer: g.func
}, gn = j({}, ke, {
  getA11yStatusMessage: g.func,
  highlightedIndex: g.number,
  defaultHighlightedIndex: g.number,
  initialHighlightedIndex: g.number,
  isOpen: g.bool,
  defaultIsOpen: g.bool,
  initialIsOpen: g.bool,
  selectedItem: g.any,
  initialSelectedItem: g.any,
  defaultSelectedItem: g.any,
  id: g.string,
  labelId: g.string,
  menuId: g.string,
  getItemId: g.func,
  toggleButtonId: g.string,
  onSelectedItemChange: g.func,
  onHighlightedIndexChange: g.func,
  onStateChange: g.func,
  onIsOpenChange: g.func,
  scrollIntoView: g.func
});
function br(t, n, r) {
  var o = n.type, i = n.props, e;
  switch (o) {
    case r.ItemMouseMove:
      e = {
        highlightedIndex: n.disabled ? -1 : n.index
      };
      break;
    case r.MenuMouseLeave:
      e = {
        highlightedIndex: -1
      };
      break;
    case r.ToggleButtonClick:
    case r.FunctionToggleMenu:
      e = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : xe(i, t, 0)
      };
      break;
    case r.FunctionOpenMenu:
      e = {
        isOpen: !0,
        highlightedIndex: xe(i, t, 0)
      };
      break;
    case r.FunctionCloseMenu:
      e = {
        isOpen: !1
      };
      break;
    case r.FunctionSetHighlightedIndex:
      e = {
        highlightedIndex: i.isItemDisabled(i.items[n.highlightedIndex], n.highlightedIndex) ? -1 : n.highlightedIndex
      };
      break;
    case r.FunctionSetInputValue:
      e = {
        inputValue: n.inputValue
      };
      break;
    case r.FunctionReset:
      e = {
        highlightedIndex: tt(i),
        isOpen: ve(i, "isOpen"),
        selectedItem: ve(i, "selectedItem"),
        inputValue: ve(i, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return j({}, t, e);
}
$e($e({}, gn), { items: g.array.isRequired, isItemDisabled: g.func });
$e($e({}, we), { isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var ut = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, st = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, at = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, lt = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, ct = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, dt = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, ft = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, pt = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, ht = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, Fe = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, gt = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, vn = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, mn = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, vt = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, _n = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, In = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, yn = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, En = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, bn = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, mt = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, wn = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, On = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, _t = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, xn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ControlledPropUpdatedSelectedItem: _t,
  FunctionCloseMenu: En,
  FunctionOpenMenu: yn,
  FunctionReset: On,
  FunctionSelectItem: mt,
  FunctionSetHighlightedIndex: bn,
  FunctionSetInputValue: wn,
  FunctionToggleMenu: In,
  InputBlur: Fe,
  InputChange: ht,
  InputClick: gt,
  InputKeyDownArrowDown: ut,
  InputKeyDownArrowUp: st,
  InputKeyDownEnd: ct,
  InputKeyDownEnter: pt,
  InputKeyDownEscape: at,
  InputKeyDownHome: lt,
  InputKeyDownPageDown: ft,
  InputKeyDownPageUp: dt,
  ItemClick: vt,
  ItemMouseMove: mn,
  MenuMouseLeave: vn,
  ToggleButtonClick: _n
});
function wr(t) {
  var n = vr(t), r = n.selectedItem, o = n.inputValue;
  return o === "" && r && t.defaultInputValue === void 0 && t.initialInputValue === void 0 && t.inputValue === void 0 && (o = t.itemToString(r)), j({}, n, {
    inputValue: o
  });
}
var Or = j({}, gn, {
  items: g.array.isRequired,
  isItemDisabled: g.func,
  inputValue: g.string,
  defaultInputValue: g.string,
  initialInputValue: g.string,
  inputId: g.string,
  onInputValueChange: g.func
});
function xr(t, n, r, o) {
  var i = ne(), e = gr(t, n, r, o), u = e[0], c = e[1], f = Be();
  return ue(function() {
    if (Le(n, "selectedItem")) {
      if (!f) {
        var E = n.itemToKey(n.selectedItem) !== n.itemToKey(i.current);
        E && c({
          type: _t,
          inputValue: n.itemToString(n.selectedItem)
        });
      }
      i.current = u.selectedItem === i.current ? n.selectedItem : u.selectedItem;
    }
  }, [u.selectedItem, n.selectedItem]), [Ke(u, n), c];
}
var Sn = ie;
process.env.NODE_ENV !== "production" && (Sn = function(n, r) {
  g.checkPropTypes(Or, n, "prop", r.name);
});
var Sr = j({}, we, {
  isItemDisabled: function() {
    return !1;
  }
});
function Cr(t, n) {
  var r, o = n.type, i = n.props, e = n.altKey, u;
  switch (o) {
    case vt:
      u = {
        isOpen: ve(i, "isOpen"),
        highlightedIndex: tt(i),
        selectedItem: i.items[n.index],
        inputValue: i.itemToString(i.items[n.index])
      };
      break;
    case ut:
      t.isOpen ? u = {
        highlightedIndex: Ie(t.highlightedIndex, 1, i.items, i.isItemDisabled, !0)
      } : u = {
        highlightedIndex: e && t.selectedItem == null ? -1 : xe(i, t, 1),
        isOpen: i.items.length >= 0
      };
      break;
    case st:
      t.isOpen ? e ? u = jt(i, t.highlightedIndex) : u = {
        highlightedIndex: Ie(t.highlightedIndex, -1, i.items, i.isItemDisabled, !0)
      } : u = {
        highlightedIndex: xe(i, t, -1),
        isOpen: i.items.length >= 0
      };
      break;
    case pt:
      u = jt(i, t.highlightedIndex);
      break;
    case at:
      u = j({
        isOpen: !1,
        highlightedIndex: -1
      }, !t.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case dt:
      u = {
        highlightedIndex: Ie(t.highlightedIndex, -10, i.items, i.isItemDisabled, !0)
      };
      break;
    case ft:
      u = {
        highlightedIndex: Ie(t.highlightedIndex, 10, i.items, i.isItemDisabled, !0)
      };
      break;
    case lt:
      u = {
        highlightedIndex: Ee(0, !1, i.items, i.isItemDisabled)
      };
      break;
    case ct:
      u = {
        highlightedIndex: Ee(i.items.length - 1, !0, i.items, i.isItemDisabled)
      };
      break;
    case Fe:
      u = j({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && ((r = i.items) == null ? void 0 : r.length) && n.selectItem && {
        selectedItem: i.items[t.highlightedIndex],
        inputValue: i.itemToString(i.items[t.highlightedIndex])
      });
      break;
    case ht:
      u = {
        isOpen: !0,
        highlightedIndex: tt(i),
        inputValue: n.inputValue
      };
      break;
    case gt:
      u = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : xe(i, t, 0)
      };
      break;
    case mt:
      u = {
        selectedItem: n.selectedItem,
        inputValue: i.itemToString(n.selectedItem)
      };
      break;
    case _t:
      u = {
        inputValue: n.inputValue
      };
      break;
    default:
      return br(t, n, xn);
  }
  return j({}, t, u);
}
var Dr = ["onMouseLeave", "refKey", "ref"], Rr = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], Tr = ["onClick", "onPress", "refKey", "ref"], Pr = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
Cn.stateChangeTypes = xn;
function Cn(t) {
  t === void 0 && (t = {}), Sn(t, Cn);
  var n = j({}, Sr, t), r = n.items, o = n.scrollIntoView, i = n.environment, e = n.getA11yStatusMessage, u = xr(Cr, n, wr, yr), c = u[0], f = u[1], E = c.isOpen, I = c.highlightedIndex, O = c.selectedItem, S = c.inputValue, P = ne(null), k = ne({}), C = ne(null), h = ne(null), q = Be(), a = pr(n), d = ne(), l = fn({
    state: c,
    props: n
  }), s = te(function(y) {
    return k.current[a.getItemId(y)];
  }, [a]);
  _r(e, c, [E, I, O, S], i);
  var D = Ir({
    menuElement: P.current,
    highlightedIndex: I,
    isOpen: E,
    itemRefs: k,
    scrollIntoView: o,
    getItemNodeFromIndex: s
  });
  hn({
    props: n,
    state: c
  }), ue(function() {
    var y = Oe(n, "isOpen");
    y && C.current && C.current.focus();
  }, []), ue(function() {
    q || (d.current = r.length);
  });
  var K = mr(i, te(function() {
    l.current.state.isOpen && f({
      type: Fe,
      selectItem: !1
    });
  }, [f, l]), It(function() {
    return [P, h, C];
  }, [P.current, h.current, C.current])), M = pn("getInputProps", "getMenuProps");
  ue(function() {
    E || (k.current = {});
  }, [E]), ue(function() {
    var y;
    !E || !(i != null && i.document) || !(C != null && (y = C.current) != null && y.focus) || i.document.activeElement !== C.current && C.current.focus();
  }, [E, i]);
  var F = It(function() {
    return {
      ArrowDown: function(_) {
        _.preventDefault(), f({
          type: ut,
          altKey: _.altKey
        });
      },
      ArrowUp: function(_) {
        _.preventDefault(), f({
          type: st,
          altKey: _.altKey
        });
      },
      Home: function(_) {
        l.current.state.isOpen && (_.preventDefault(), f({
          type: lt
        }));
      },
      End: function(_) {
        l.current.state.isOpen && (_.preventDefault(), f({
          type: ct
        }));
      },
      Escape: function(_) {
        var v = l.current.state;
        (v.isOpen || v.inputValue || v.selectedItem || v.highlightedIndex > -1) && (_.preventDefault(), f({
          type: at
        }));
      },
      Enter: function(_) {
        var v = l.current.state;
        !v.isOpen || _.which === 229 || (_.preventDefault(), f({
          type: pt
        }));
      },
      PageUp: function(_) {
        l.current.state.isOpen && (_.preventDefault(), f({
          type: dt
        }));
      },
      PageDown: function(_) {
        l.current.state.isOpen && (_.preventDefault(), f({
          type: ft
        }));
      }
    };
  }, [f, l]), H = te(function(y) {
    return j({
      id: a.labelId,
      htmlFor: a.inputId
    }, y);
  }, [a]), L = te(function(y, _) {
    var v, w = y === void 0 ? {} : y, R = w.onMouseLeave, T = w.refKey, V = T === void 0 ? "ref" : T, $ = w.ref, A = pe(w, Dr), G = _ === void 0 ? {} : _, m = G.suppressRefError, Z = m === void 0 ? !1 : m;
    return M("getMenuProps", Z, V, P), j((v = {}, v[V] = ye($, function(x) {
      P.current = x;
    }), v.id = a.menuId, v.role = "listbox", v["aria-labelledby"] = A && A["aria-label"] ? void 0 : "" + a.labelId, v.onMouseLeave = ee(R, function() {
      f({
        type: vn
      });
    }), v), A);
  }, [f, M, a]), B = te(function(y) {
    var _, v, w = y === void 0 ? {} : y, R = w.item, T = w.index, V = w.refKey, $ = V === void 0 ? "ref" : V, A = w.ref, G = w.onMouseMove, m = w.onMouseDown, Z = w.onClick;
    w.onPress;
    var x = w.disabled, le = pe(w, Rr);
    x !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var ce = l.current, me = ce.props, de = ce.state, Se = hr(R, T, me.items, "Pass either item or index to getItemProps!"), qe = Se[0], fe = Se[1], be = me.isItemDisabled(qe, fe), Ye = "onClick", Ce = Z, he = function() {
      K.isTouchEnd || fe === de.highlightedIndex || (D.current = !1, f({
        type: mn,
        index: fe,
        disabled: be
      }));
    }, _e = function() {
      f({
        type: vt,
        index: fe
      });
    }, ge = function(Dn) {
      return Dn.preventDefault();
    };
    return j((_ = {}, _[$] = ye(A, function(ae) {
      ae && (k.current[a.getItemId(fe)] = ae);
    }), _["aria-disabled"] = be, _["aria-selected"] = fe === de.highlightedIndex, _.id = a.getItemId(fe), _.role = "option", _), !be && (v = {}, v[Ye] = ee(Ce, _e), v), {
      onMouseMove: ee(G, he),
      onMouseDown: ee(m, ge)
    }, le);
  }, [f, a, l, K, D]), X = te(function(y) {
    var _, v = y === void 0 ? {} : y, w = v.onClick;
    v.onPress;
    var R = v.refKey, T = R === void 0 ? "ref" : R, V = v.ref, $ = pe(v, Tr), A = l.current.state, G = function() {
      f({
        type: _n
      });
    };
    return j((_ = {}, _[T] = ye(V, function(m) {
      h.current = m;
    }), _["aria-controls"] = a.menuId, _["aria-expanded"] = A.isOpen, _.id = a.toggleButtonId, _.tabIndex = -1, _), !$.disabled && j({}, {
      onClick: ee(w, G)
    }), $);
  }, [f, l, a]), N = te(function(y, _) {
    var v, w = y === void 0 ? {} : y, R = w.onKeyDown, T = w.onChange, V = w.onInput, $ = w.onBlur;
    w.onChangeText;
    var A = w.onClick, G = w.refKey, m = G === void 0 ? "ref" : G, Z = w.ref, x = pe(w, Pr), le = _ === void 0 ? {} : _, ce = le.suppressRefError, me = ce === void 0 ? !1 : ce;
    M("getInputProps", me, m, C);
    var de = l.current.state, Se = function(ge) {
      var ae = Qe(ge);
      ae && F[ae] && F[ae](ge);
    }, qe = function(ge) {
      f({
        type: ht,
        inputValue: ge.target.value
      });
    }, fe = function(ge) {
      if (i != null && i.document && de.isOpen && !K.isMouseDown) {
        var ae = ge.relatedTarget === null && i.document.activeElement !== i.document.body;
        f({
          type: Fe,
          selectItem: !ae
        });
      }
    }, be = function() {
      f({
        type: gt
      });
    }, Ye = "onChange", Ce = {};
    if (!x.disabled) {
      var he;
      Ce = (he = {}, he[Ye] = ee(T, V, qe), he.onKeyDown = ee(R, Se), he.onBlur = ee($, fe), he.onClick = ee(A, be), he);
    }
    return j((v = {}, v[m] = ye(Z, function(_e) {
      C.current = _e;
    }), v["aria-activedescendant"] = de.isOpen && de.highlightedIndex > -1 ? a.getItemId(de.highlightedIndex) : "", v["aria-autocomplete"] = "list", v["aria-controls"] = a.menuId, v["aria-expanded"] = de.isOpen, v["aria-labelledby"] = x && x["aria-label"] ? void 0 : a.labelId, v.autoComplete = "off", v.id = a.inputId, v.role = "combobox", v.value = de.inputValue, v), Ce, x);
  }, [f, a, i, F, l, K, M]), Q = te(function() {
    f({
      type: In
    });
  }, [f]), J = te(function() {
    f({
      type: En
    });
  }, [f]), re = te(function() {
    f({
      type: yn
    });
  }, [f]), oe = te(function(y) {
    f({
      type: bn,
      highlightedIndex: y
    });
  }, [f]), se = te(function(y) {
    f({
      type: mt,
      selectedItem: y
    });
  }, [f]), p = te(function(y) {
    f({
      type: wn,
      inputValue: y
    });
  }, [f]), b = te(function() {
    f({
      type: On
    });
  }, [f]);
  return {
    // prop getters.
    getItemProps: B,
    getLabelProps: H,
    getMenuProps: L,
    getInputProps: N,
    getToggleButtonProps: X,
    // actions.
    toggleMenu: Q,
    openMenu: re,
    closeMenu: J,
    setHighlightedIndex: oe,
    setInputValue: p,
    selectItem: se,
    reset: b,
    // state.
    highlightedIndex: I,
    isOpen: E,
    selectedItem: O,
    inputValue: S
  };
}
ke.stateReducer, ke.itemToKey, ke.environment, g.array, g.array, g.array, g.func, g.number, g.number, g.number, g.func, g.func, g.string, g.string;
we.itemToKey, we.stateReducer, we.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
export {
  Cn as u
};
